<div class="container-fluid-modal">

  <form #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm()" novalidate>

    <div class="add" *ngIf="!editData">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Add Body Part</h4>
        <div class="headerButton">
          <button type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
          </button>
          <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i class="fa fa-times"aria-hidden="true"></i>
            Cancel
          </button>
        </div>
      </div>

      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
            <div class="form-group col-lg-12">
              <div class="form-group col-lg-12">
                <label class="labelRequired">Type </label>
                <select class="form-control" [(ngModel)]="user.type"
                        data-show-content="true" name="type" #type="ngModel"placeholder="Select the Type"
                        required [ngClass]="{'has-danger': cat?.submitted  && name?.invalid }">
                <div *ngIf="cat?.submitted  && type?.invalid ">
                  <div [hidden]="!type.errors.required" class="formError"> * Type is required</div>
                </div>
                  <option disabled>Select the Type</option>
                  <option value="1">Implants</option>
                  <option value="2">Consumable</option>
                </select>
              </div>
              <div class="form-group col-lg-12">
                <label for="Name" class="labelRequired">Name </label>
                <input id="Name" type="text" class="form-control" placeholder="Name" name="name" #name="ngModel"
                       [(ngModel)]="user.name" required [ngClass]="{'has-danger': cat?.submitted  && name?.invalid }">
                <div *ngIf="cat?.submitted  && name?.invalid ">
                  <div [hidden]="!name.errors.required" class="formError"> * Body Part name is required</div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </mat-dialog-content>
    </div>

    <div class="edit" *ngIf="editData">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Edit Body Part</h4>
        <div class="headerButton">
          <button type="submit" class="btn btn-success" *ngIf="editPermission"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
          </button>
          <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i
            class="fa fa-times" aria-hidden="true"></i> Cancel
          </button>
        </div>
      </div>

      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
            <div class="form-group col-lg-12">
              <div class="form-group col-lg-12">
                <label class="labelRequired">Type </label>
                <select class="form-control"
                        data-show-content="true" name="type" placeholder="Select the Type"
                        required [(ngModel)]="editData.type">
                  <option disabled>Select the Type</option>
                  <option value="1">Implants</option>
                  <option value="2">Consumable</option>
                </select>
              </div>
              <div class="form-group col-lg-12">
                <label for="Name" class="labelRequired">Name </label>
                <input type="text" class="form-control" placeholder="Name" name="name" [(ngModel)]="editData.name"
                       required #name="ngModel" [ngClass]="{'has-danger':name?.invalid && name?.touched }">
                <div *ngIf="name?.errors && (name?.dirty || name?.touched)">
                  <div [hidden]="!name.errors.required" class="formError"> * Body Part name is required</div>
                </div>
              </div>
            </div>

          </div>

        </div>

      </mat-dialog-content>
    </div>

  </form>
</div>
